(ns quuppa.qsm.dashboard.events
  (:require [clojure.string :as str]
            [re-frame.core :as rf]))

(rf/reg-event-db
  :select-log-file
  (fn [db [_ file-name]]
    (update-in db [:ui-state :selected-files]
               (fn [selected-files]
                 (let [selected-files (or selected-files #{})]
                   (if (contains? selected-files file-name)
                     (disj selected-files file-name)
                     (conj selected-files file-name)))))))

(rf/reg-event-fx
  :qsm/req-list-logs
  (fn [_ [_ _]]
    {:fx [[:server-dispatch {:event [:qsm/req-list-logs]
                             :on-success [:qsm/clear-selected-logs]
                             :timeout    60000 ;; reading logs can take time
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to get logs"
                                         :message    (str "Failed to get logs, please refresh the page")}]}]]}))

(rf/reg-event-fx
  :qsm/req-delete-logs
  (fn [_ [_ {:keys [file-names] :as args}]]
    {:fx [[:server-dispatch {:event [:qsm/req-delete-logs args]
                             :on-success [:qsm/req-list-logs]
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to delete logs!"
                                         :message    (str "Failed to delete logs: " (str/join "," file-names))}]}]]}))
(rf/reg-event-db
  :qsm/clear-selected-logs
  (fn [db [_ _]]
    (-> db
        (update-in [:ui-state] dissoc :selected-files))))

(rf/reg-event-db
  :qsm/add-logs
  (fn [db [_ {:keys [logs]}]]
    (assoc-in db [:ui-state :qsm-logs] logs)))
